import { useSnackbar } from 'notistack';

const useNotification = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  /**
   * Triggers a snackbar notification.
   *
   * @param message - The message to display in the snackbar.
   * @param variant - The type of notification ('default', 'success', 'error', 'warning', 'info').
   * @param options - Additional options for customizing the snackbar.
   */
  const notify = (
    message: string,
    variant: 'default' | 'success' | 'error' | 'warning' | 'info' = 'default',
    options = {}
  ) => {
    enqueueSnackbar(message, { variant, ...options });
  };
  /**
     * Displays a full-width banner notification at the top of the page.
     *
     * @param message - The message to display in the banner.
     * @param variant - The type of notification ('default', 'success', 'error', 'warning', 'info').
     * @param options - Additional options for customizing the banner's appearance.
     */

  const showBanner = (
    message: string,
    variant: 'default' | 'success' | 'error' | 'warning' | 'info' = 'default',
    options = {}
  ) => {
    enqueueSnackbar(message, {

      variant,
      autoHideDuration: 6000,
      // persist: true, // Ensures the banner stays until manually closed
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      // content: (key, message) => (
      //   <div
      //     style={{
      //       width: '100%',
      //       backgroundColor: variant === 'success' ? '#4caf50' : '#f44336',
      //       color: '#fff',
      //       padding: '10px 20px',
      //       boxSizing: 'border-box',
      //       display: 'flex',
      //       flex:1,
      //       justifyContent: 'space-between',
      //       alignItems: 'center',
      //     }}
      //   >
      //     <span>{message}</span>
      //     <button
      //       style={{
      //         background: 'none',
      //         border: 'none',
      //         color: '#fff',
      //         fontSize: '16px',
      //         cursor: 'pointer',
      //       }}
      //       onClick={() => closeSnackbar(key)}
      //     >
      //       ✖
      //     </button>
      //   </div>
      // ),
      ...options,
    });
  };


  /**
   * Dismisses all or a specific snackbar.
   *
   * @param key - The key of the snackbar to close (optional).
   */
  const dismiss = (key?: string | number) => {
    closeSnackbar(key);
  };

  return { notify, dismiss, showBanner };
};

export default useNotification;
